import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setCompanyDetailsData } from '../../../redux/companyDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/companies/editCompany/updateCompanyAddress.css';

export const UpdateCompanyAddress = ({ openUpdateAddress, setOpenUpdateAddress }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const companyDetailsData = useSelector((state) => state.CompanyDetailsData);

    const formik = useFormik({
        initialValues: {
            street_address: companyDetailsData?.street_address || '',
            address_line_2: companyDetailsData?.address_line_2 || '',
            city: companyDetailsData?.city || '',
            postal_code: companyDetailsData?.postal_code || '',
            can_manage_machine_control: companyDetailsData?.can_manage_machine_control || false,
        },
        validationSchema: Yup.object().shape({
            street_address: Yup.string().optional(),
            address_line_2: Yup.string().optional(),
            city: Yup.string().optional(),
            postal_code: Yup.string().optional(),
            can_manage_machine_control: Yup.boolean().optional(),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`company/${id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: t("Modification l’adresse de l’entreprise") }));
                    dispatch(setCompanyDetailsData({
                        ...companyDetailsData,
                        street_address: response?.data?.street_address,
                        address_line_2: response?.data?.address_line_2,
                        city: response?.data?.city,
                        postal_code: response?.data?.postal_code,
                        can_manage_machine_control: response?.data?.can_manage_machine_control
                    }));
                    setOpenUpdateAddress(false);
                }
            } catch (error) {
                console.error('Erreur lors de la mise à jour de l’adresse de l’entreprise :', error);
                CustomErrorLogger(error, 'Échec de mise à jour de l’adresse dans UpdateCompanyAddress');
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

    return (
        <Dialog open={openUpdateAddress} fullWidth>
            <Box onClick={() => setOpenUpdateAddress(false)} className='updateCompanyAddress_icon_text'>
                <Typography className='updateCompanyAddress_title'>Modification l’adresse de l’entreprise</Typography>
                <Iconify icon="material-symbols:close" className='updateCompanyAddress_close_icon' />
            </Box>
            <form onSubmit={handleSubmit}>
                <DialogContent className='updateCompanyAddress_dialog_content'>
                    <Box className="updateCompanyAddress_helper_input_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateCompanyAddressInputTitle">Adresse (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.street_address}
                            className='updateCompanyAddress_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="street_address"
                            error={touched.street_address && Boolean(errors.street_address)}
                            helperText={touched.street_address && errors.street_address}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateCompanyAddress_helper_input_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateCompanyAddressInputTitle">Complément d'adresse (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.address_line_2}
                            className='updateCompanyAddress_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="address_line_2"
                            error={touched.address_line_2 && Boolean(errors.address_line_2)}
                            helperText={touched.address_line_2 && errors.address_line_2}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateCompanyAddress_helper_input_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateCompanyAddressInputTitle">Ville (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.city}
                            className='updateCompanyAddress_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="city"
                            error={touched.city && Boolean(errors.city)}
                            helperText={touched.city && errors.city}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateCompanyAddress_helper_input_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateCompanyAddressInputTitle">Postal code (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.postal_code}
                            className='updateCompanyAddress_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="postal_code"
                            error={touched.postal_code && Boolean(errors.postal_code)}
                            helperText={touched.postal_code && errors.postal_code}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateCompanyAddress_helper_input_box">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={values.can_manage_machine_control}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="can_manage_machine_control"
                                    sx={{
                                        '&.Mui-checked': {
                                            color: '#EA5E00',
                                        },
                                    }}
                                />
                            }
                            label='Peut gérer le contrôle des machines'
                        />
                        {touched.can_manage_machine_control && errors.can_manage_machine_control && (
                            <FormHelperText error>{errors.can_manage_machine_control}</FormHelperText>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions className='updateCompanyAddress_dialog_actions'>
                    <Button className='updateCompanyAddress_button_annuler' onClick={() => setOpenUpdateAddress(false)}>{t('Annuler')}</Button>
                    <Button className='updateCompanyAddress_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};